<template>
  <div>
    <div class="select_wrap">
      <div class="col-xs-6 scenario_select">
        <div class="select_arrow">
          <select
              v-model="citySelect"
              @change="resetArea()"
          >
            <option value="" selected="selected" disabled>請選擇縣市</option>
            <option
                v-for="city in citys"
                :key=city
                :value=city
            >
              {{ city }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-6 scenario_select">
        <div class="select_arrow">
          <select
              v-model="areaSelect"
              @change="setDropDown()"
          >
            <option value="" selected>請選擇區域</option>
            <option
                v-for="areaOption in areaOptions"
                @change="setDropDown()"
                :key=areaOption
                :value=areaOption
            >
              {{ areaOption }}
            </option>
          </select>
        </div>
      </div>
      <p v-if="isEmpty" style="color: red">請選擇選項</p>
    </div>
  </div>

</template>

<script>
import {dispatch, get} from "vuex-pathify";

export default {
  name: "city_area_dropdown",
  props: {
    page_no: Number
  },
  data: function () {
    return {
      citySelect: '',
      areaSelect: '',
      citys: {
        0: "基隆市",
        1: "台北市",
        2: "新北市",
        3: "桃園市",
        4: "新竹市",
        5: "新竹縣",
        6: "苗栗縣",
        7: "台中市",
        8: "彰化縣",
        9: "南投縣",
        10: "雲林縣",
        11: "嘉義市",
        12: "嘉義縣",
        13: "台南市",
        14: "高雄市",
        15: "屏東縣",
        16: "宜蘭縣",
        17: "花蓮縣",
        18: "台東市",
        19: "澎湖縣",
        20: "金門縣",
        21: "連江縣",
      },
      areas: {
        "台中市": ["南區", "西區", "東區", "北區", "北屯區", "南屯區", "西屯區", "豐原區", "神岡區", "后里區", "大安區", "外埔區", "大甲區", "清水區", "梧棲區", "沙鹿區", "石岡區", "東勢區", "潭子區", "大雅區", "大里區", "烏日區", "霧峰區", "太平區", "龍井區", "大肚區", "中區"],
        "台北市": ["文山區", "中正區", "大同區", "內湖區", "中山區", "松山區", "南港區", "北投區", "士林區", "大安區", "萬華區", "信義區"],
        "台東市": ["台東市", "成功鎮", "太麻里鄉", "卑南鄉"],
        "台南市": ["北區", "中西區", "安平區", "安南區", "南區", "東區", "新營區", "鹽水區", "官田區", "六甲區", "麻豆區", "佳里區", "善化區", "歸仁區", "永康區", "仁德區", "新化區", "西港區", "白河區", "新市區", "山上區", "關廟區", "後壁區", "柳營區", "安定區", "學甲區", "玉井區"],
        "宜蘭縣": ["羅東鎮", "三星鄉", "冬山鄉", "五結鄉", "礁溪鄉", "宜蘭市", "壯圍鄉", "員山鄉", "蘇澳鎮", "頭城鎮"],
        "花蓮縣": ["新城鄉", "花蓮市", "吉安鄉", "壽豐鄉", "光復鄉", "玉里鎮", "鳳林鎮"],
        "金門縣": ["金湖鎮", "金寧鄉", "金城鎮"],
        "南投縣": ["南投市", "名間鄉", "草屯鎮", "埔里鎮", "魚池鄉", "竹山鎮", "中寮鄉", "水里鄉", "國姓鄉"],
        "屏東縣": ["屏東巿", "九如鄉", "潮州鎮", "新埤鄉", "內埔鄉", "新園鄉", "東港鎮", "恆春鎮", "佳冬鄉", "枋寮鄉", "萬巒鄉", "高樹鄉", "萬丹鄉", "麟洛鄉", "長治鄉"],
        "苗栗縣": ["公館鄉", "苗栗市", "苑裡鎮", "後龍鎮", "竹南鎮", "造橋鄉", "西湖鄉", "頭份巿", "通霄鎮", "卓蘭鎮", "銅鑼鄉"],
        "桃園市": ["桃園區", "中壢區", "觀音區", "龍潭區", "大溪區", "楊梅區", "蘆竹區", "八德區", "平鎮區", "龜山區", "新屋區", "大園區"],
        "高雄市": ["鼓山區", "前金區", "鹽埕區", "苓雅區", "新興區", "前鎮區", "小港區", "三民區", "楠梓區", "左營區", "岡山區", "橋頭區", "燕巢區", "大樹區", "鳳山區", "仁武區", "鳥松區", "茄萣區", "路竹區", "阿蓮區", "大寮區", "林園區", "湖內區", "大社區", "旗山區", "甲仙區", "梓官區", "旗津區", "彌陀區"],
        "基隆市": ["仁愛區", "中正區", "信義區", "中山區", "安樂區", "暖暖區", "七堵區"],
        "連江縣": ["北竿鄉"],
        "雲林縣": ["斗六市", "虎尾鎮", "麥寮鄉", "林內鄉", "西螺鎮", "土庫鎮", "斗南鎮", "北港鎮", "四湖鄉", "元長鄉", "古坑鄉", "二崙鄉", "莿桐鄉"],
        "新北市": ["板橋區", "土城區", "五股區", "新莊區", "林口區", "泰山區", "新店區", "汐止區", "淡水區", "瑞芳區", "蘆洲區", "三重區", "永和區", "中和區", "鶯歌區", "三峽區", "樹林區", "金山區", "八里區", "深坑區", "三芝區", "貢寮區", "萬里區"],
        "新竹市": ["不分區域"],
        "新竹縣": ["不分區域"],
        "嘉義市": ["不分區域"],
        "嘉義縣": ["布袋鎮", "民雄鄉", "大林鎮", "水上鄉", "太保市", "朴子市", "中埔鄉", "大埔鄉", "鹿草鄉", "梅山鄉"],
        "彰化縣": ["線西鄉", "伸港鄉", "和美鎮", "鹿港鎮", "員林市", "社頭鄉", "田尾鄉", "埤頭鄉", "二林鎮", "埔鹽鄉", "溪湖鎮", "埔心鄉", "竹塘鄉", "芳苑鄉", "北斗鎮", "田中鎮", "福興鄉", "花壇鄉", "彰化市", "大村鄉", "秀水鄉", "永靖鄉"],
        "澎湖縣": ["馬公市", "湖西鄉"]
      }
    }
  },
  methods: {
    resetArea() {
      this.areaSelect = ''
    },
    setDropDown() {
      let moduleName = store.get('moduleName')
      if (this.citySelect !== '' && this.areaSelect !== '') {
        let payload = {
          page_no: this.page_no,
          page_answer: {
            county: this.citySelect,
            city: this.areaSelect
          }
        }
        console.log(this.citySelect, this.areaSelect)
        store.set(`${moduleName}/isEmpty`, false)
        dispatch(`${moduleName}/setPostData`, payload)
      } else store.set(`${moduleName}/isEmpty`, true)
    }
  }
  ,
  computed: {
    areaOptions: (data) => {
      if (data.citySelect === '') {
        data.areaSelect = ""
        return []
      }
      return data.areas[data.citySelect];
    },
    ...get('buyHouse', {
      isEmpty: 'isEmpty',
    })
  },
}
</script>

<style scoped>

</style>